import React, { Component } from 'react'
import Button from '~/Common-Objects/UI/Forms/Button/Button'
import ImageCustomiser from '~/Common-Objects/ImageCustomiser/ImageCustomiser'
import * as siteMaster from '~/data/actions/siteActions' //now we can use user actions here
import { connect } from 'react-redux'
import FileManager from '~/pages/cp/includes/fileManager/fileManager'
import SiteVars from '~/Classes/siteVars'
import { launchAviary } from '~/Classes/aviaryEditor'
import jquery from 'jquery'
import i18n from '~/i18n'
import ImagePicker from '~/Common-Objects/ImagePicker'
//CONNECT TO STORE
@connect((store) => {
    return { user: store.user, accountMaster: store.accountMaster }
})
export default class ComponentText extends Component {
    constructor(props) {
        super(props)

        this.state = {
            hostingType: 0,
            showPop: false,
            popupStyle: {}
        }
        this.openImagePicker = this.openImagePicker.bind(this)
        this.onFileClick = this.onFileClick.bind(this)
        this.onClearClick = this.onClearClick.bind(this)
        this.editImage = this.editImage.bind(this)
        this.changeHostingType = this.changeHostingType.bind(this)
        this.changeImageUrl = this.changeImageUrl.bind(this)
        this.changeImageUrlFixed = this.changeImageUrlFixed.bind(this)
        this.resizePopup = this.resizePopup.bind(this)
        this.customiseImageToggle = this.customiseImageToggle.bind(this)
    }

    componentWillMount() {
        window.addEventListener('click', this.customiseImageToggle)
        var hostingType = 0
        if (
            this.props.value.indexOf(SiteVars.repoEndPoint) < 0 &&
            this.props.value.indexOf('cdn1.ourmailsender.com') < 0 &&
            this.props.value != ''
        )
            hostingType = 1
        if (this.props.value.indexOf('/api/dynamicimage?') > -1) hostingType = 0
        this.setState({ hostingType })
    }
    componentWillUnmount() {
        window.removeEventListener('click', this.customiseImageToggle)
    }

    openImagePicker() {
        let fileTypes = 'images'
        if (this.props.isLandingPage || this.props.isForm) fileTypes = 'websiteImages'
        var theDrawer = <FileManager onFileClick={this.onFileClick} fileTypes={fileTypes} />
        this.props.dispatch(siteMaster.alterSiteDrawer(true, true, 'right', theDrawer, true, '100vw', 'fix-height'))
    }

    async onFileClick(newFile) {
        this.props.dispatch(siteMaster.alterSiteDrawer(false, true, 'right', null, true, null))
        await this.props.updateVal(this.props.path, newFile.url)
        if (this.props.localVariables && this.props.localVariables.fileSize) {
            await this.props.updateVal('localVariables.fileSize', newFile.size)
        }
        if (this.props.localVariables && this.props.localVariables.srcImageWidth) {
            await this.props.updateVal('localVariables.srcImageWidth', newFile.imageWidth || 0)
        }
        if (this.props.localVariables && this.props.localVariables.srcImageHeight) {
            await this.props.updateVal('localVariables.srcImageHeight', newFile.imageHeight || 0)
        }
    }
    onClearClick() {
        this.props.updateVal(this.props.path, '')
    }

    editImage() {
        var self = this
        var filePath = this.props.value
        if (filePath.indexOf('_mpi_') > -1) {
            var spDat = filePath.split('_mpi_')
            filePath = spDat[0] + spDat[spDat.length - 1]
        }
        launchAviary(
            null,
            null,
            (newImgUrl) => {
                self.onFileClick({ url: newImgUrl })
            },
            this.props.value
        )
    }

    changeHostingType() {
        var hostingType = this.state.hostingType
        if (hostingType == 0) {
            hostingType = 1
        } else {
            hostingType = 0
        }
        this.setState({ hostingType })
    }

    changeImageUrl(value) {
        this.props.updateVal(this.props.path, value)
    }

    changeImageUrlFixed(newUrl) {
        this.props.updateVal(this.props.path, newUrl)
    }

    customiseImageToggle(ev) {
        var target = jquery(ev.target)

        if (
            (ev.target.id && ev.target.id == 'imageEditor_' + this.props.index) ||
            target.parents('div#imageEditor_' + this.props.index).length
        ) {
            this.setState({ showPop: true }, this.resizePopup)
        } else {
            this.setState({ showPop: false })
        }
    }
    resizePopup() {
        var popupStyle = {
            width: '500px'
        }
        var triggerRect = this.refs.ourHolder.getBoundingClientRect()
        var ourRect = this.refs.popupHolder
        popupStyle.left = triggerRect.left - (ourRect.offsetWidth + 40)
        popupStyle.top = triggerRect.top - 25

        var bottomPx = popupStyle.top + ourRect.offsetHeight
        if (bottomPx > window.innerHeight) {
            popupStyle.top = window.innerHeight - ourRect.offsetHeight
        }

        this.setState({ popupStyle })
    }
    render() {
        var style = {}
        if (this.props.elementData.optionFullWidth || this.props.fullWidth) style = { flex: '100%' }
        var imageUrl = this.props.value
        if (this.props.value == '{{__COMPANYLOGO}}') {
            imageUrl = SiteVars.repoEndPoint + this.props.accountMaster.accountMaster.companyLogo
        }

        var isEditable = false
        var isDynamic = false
        if (
            imageUrl.indexOf('/templates/') < 0 &&
            imageUrl.indexOf('_mpi_') < 0 &&
            imageUrl.indexOf('/siteContent/assets/templates/common/') < 0 &&
            imageUrl.indexOf('userContent/' + this.props.accountMaster.id + '/') > 0
        ) {
            isEditable = true
        }
        if (imageUrl.indexOf('/api/dynamicimage?') > -1) {
            isEditable = true
            isDynamic = true
        }

        let tooBigToEdit = ''
        if (
            this.props.localVariables &&
            this.props.localVariables.fileSize &&
            this.props.localVariables.fileSize.value &&
            this.props.localVariables.fileSize.value > 2000000
        ) {
            tooBigToEdit = 'Filesize is too large to allow customisation'
        }
        if (
            this.props.localVariables &&
            this.props.localVariables.srcImageHeight &&
            this.props.localVariables.srcImageHeight.value &&
            this.props.localVariables.srcImageHeight.value > 1000
        ) {
            tooBigToEdit = 'The image height is bigger than 1000px so is not customisable'
        }
        if (
            this.props.localVariables &&
            this.props.localVariables.srcImageWidth &&
            this.props.localVariables.srcImageWidth.value &&
            this.props.localVariables.srcImageWidth.value > 1000
        ) {
            tooBigToEdit = 'The image width is bigger than 1000px so is not customisable'
        }

        return (
            <div className='dndEditorv2-dd_toolHolder' style={style}>
                <div className='dd_inputTool'>
                    {this.props.title && <p className='txtInput_label'>{this.props.title}</p>}
                    <ImagePicker
                        onImageClick={this.openImagePicker}
                        imageUrl={imageUrl}
                        isEditable={isEditable}
                        isDynamic={isDynamic}
                        onCustomUrlClick={this.changeHostingType}
                        isCustomUrl={this.state.hostingType == 1}
                        onCustomUrlChange={this.changeImageUrl}
                        onEditClick={this.editImage}
                    />
                </div>

                {this.state.showPop && (
                    <div
                        className='clusterPopupHolder'
                        ref='popupHolder'
                        onClick={(ev) => {
                            ev.stopPropagation()
                        }}
                        style={this.state.popupStyle}
                    >
                        <div className='clusterPopTitle' style={{ position: 'relative' }}>
                            {i18n.t('templates:add.drag.image.customise')}
                            <div style={{ position: 'absolute', right: '10px', top: '15px' }}>
                                <Button
                                    text={i18n.t('templates:add.drag.image.exit')}
                                    onClick={this.customiseImageToggle}
                                />
                            </div>
                        </div>
                        <div className='clusterPopContent'>
                            <ImageCustomiser imgSrc={imageUrl} onSave={this.changeImageUrlFixed} />
                        </div>
                    </div>
                )}
            </div>
        )
    }
}
